import URLFiltersHoc from './URLFiltersHoc';

export * from './URLFiltersHoc';
export default URLFiltersHoc;
